import React, { useContext, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { AuthContext } from "../../context/auth.context"
import { AddConfig } from "../config-editor/add-config.component"
import { UpdateConfig } from "../config-editor/update-config.component"
import { AllConfig } from "../config-editor/all-config.component"
import { SmsHandler } from "../sms-send/sms-send.component"
import { DeliveryLogHandler } from "../sms-delivery/sms-delivery.component"
import { AddTemplate } from "../template-info/add-template.component"
import { UpdateTemplate } from "../template-info/update-template.component"
import { TemplateTable } from "../template-info/template-table.component"
import { UploadXl2Json } from "../template-info/uploadXL.component"
import SideMenu from "./side.menu.component"
import { AllSenderId } from "../config-editor/all-sender-id.component"
import { AddSenderId } from "../config-editor/add-sender-id.component"
import { UpdateSenderId } from "../config-editor/update-sender-id.component"
import { AllDLTEntityId } from "../config-editor/all-dltentity-id.component"
import { AllWhatsAppConfig } from "../whatsapp-config-editor/all-whatsapp-config.component"
import { AddWhatsAppConfig } from "../whatsapp-config-editor/add-whatsapp-config.component"
import { UpdateWhatsAppConfig } from "../whatsapp-config-editor/update-whatsapp-config.component"
import { WhatsAppTemplateTable } from "../whatsapp-template-info/whatsapp-template-table.component"
import { WhatsAppUpdateTemplate } from "../whatsapp-template-info/whatsapp-update-template.component"
import { AllCampaign } from "../campaign/all-campaign.component"
import { AddCampaign } from "../campaign/add-campaign.component"
import { UpdateCampaign } from "../campaign/update-campaign.component"
import { getCookie, isAuth, signOut } from "../../helper/auth"
import Button from "../atoms/button.atom"
import { EndpointConfig, RoutesConfig } from "../../config"
import { axiosInstance } from "../../lib/axios"

function Dashboard() {
	const { auth, setAuth } = useContext(AuthContext)
	const [screenId, setScreenId] = useState("CONFIG_MANAGER")

	const [configMenuId, setConfigMenu] = useState("ALL_CONFIG")
	const [templateMenuId, setTemplateMenu] = useState("ALL_TEMPLATES")
	const [smsMenuId, setSmsMenu] = useState("SEND_SMS")
	const [smsDeliveryLogMenuId, setsmsDeliveryLogMenu] = useState("ALL_DELIVERY_LOG")

	const location = useLocation()
	const navigation = useNavigate()
	useEffect(() => {
		if (!isAuth() || isAuth().role !== "User") {
			navigation(RoutesConfig.UserLogin)
		}

		const urlSearchParam = new URLSearchParams(location.search)

		const hubspotDetails = {}
		for (const [key, value] of urlSearchParam) {
			hubspotDetails[key] = value
		}

		setAuth({ hubId: hubspotDetails.hubId })
	}, [])

	const logout = async () => {
		const token = getCookie("token")
		await axiosInstance.post(
			EndpointConfig.Logout,
			{},
			{
				headers: {
					Authorization: `Bearer ${token}`
				},
				withCredentials: true
			}
		)
		signOut()
		navigation(RoutesConfig.UserLogin)
	}
	const doOauth = async () => {
		navigation(RoutesConfig.Login)
	}

	const hubId = auth.hubId

	return (
		<>
			{hubId && (
				<div className="flex flex-col h-full">
					<div
						className="flex flex-row items-center text-gray-500 bg-white shadow"
						key="nav"
					>
						<div className="p-2">
							{/* {" "}
							<CubeTransparentIcon className="w-6 h-6 " />
							Value First{" "} */}

							<img className="h-10" src="./logo.png" alt="Logo" />
						</div>
						<div className="flex flex-row flex-1 h-10 mx-4 ">
							{[
								{ id: "CONFIG_MANAGER", text: "Configuration" },
								{ id: "TEMPLATE_MANAGER", text: "Templates" },
								{ id: "SMS_MANAGER", text: "Message Sender" }
								// { id: "DELIVERY_LOG", text: "Logs" }
							].map((screen) => {
								return (
									<div
										key={screen.id}
										onClick={() => setScreenId(screen.id)}
										className={`text-sm border-0  hover:bg-blue-200  cursor-pointer text-md whitespace-nowrap flex justify-center items-center ${
											screenId === screen.id
												? "border-b-2  bg-blue-100 border-blue-500"
												: "border-blue-200"
										}`}
									>
										<span className="px-4">{screen.text}</span>
									</div>
								)
							})}
						</div>
						<div className="px-2 text-sm font-bold">
							<Button onClick={() => logout()}>Logout</Button>
						</div>
						<div className="px-2 text-sm font-bold">
							<Button onClick={() => doOauth()}>OAuth</Button>
						</div>
					</div>
					<div className="flex-1 w-full p-4">
						{screenId === "CONFIG_MANAGER" && (
							<div className="flex flex-row justify-center h-full gap-4">
								<SideMenu
									menuList={[
										{ id: "ALL_CONFIG", text: "SMS Configurations" },
										{ id: "ALL_SENDER_ID", text: "SMS Sender Id" },
										{ id: "ALL_DLTENTITY_ID", text: "DLT Entity Id" },
										{
											id: "ALL_WHATSAPP_CONFIG",
											text: "WhatsApp Configurations"
										}
									]}
									screenId={configMenuId}
									setActiveScreenId={setConfigMenu}
								/>
								<div className="flex flex-col flex-1 overflow-x-auto ">
									{configMenuId === "ALL_CONFIG" && (
										<AllConfig
											hubId={hubId}
											onAddConfig={() => setConfigMenu("ADD_CONFIG")}
											onUpdateConfig={() => setConfigMenu("UPDATE_CONFIG")}
										/>
									)}
									{configMenuId === "ADD_CONFIG" && (
										<AddConfig
											hubId={hubId}
											onAddConfig={() => setConfigMenu("ALL_CONFIG")}
										/>
									)}
									{configMenuId === "UPDATE_CONFIG" && (
										<UpdateConfig
											hubId={hubId}
											onUpdateConfig={() => setConfigMenu("ALL_CONFIG")}
										/>
									)}
									{configMenuId === "ALL_SENDER_ID" && (
										<AllSenderId
											hubId={hubId}
											onAddRecord={() => setConfigMenu("ADD_SENDERID")}
											onUpdateRecord={() => setConfigMenu("UPDATE_SENDERID")}
										/>
									)}
									{configMenuId === "ADD_SENDERID" && (
										<AddSenderId
											hubId={hubId}
											onAddRecord={() => setConfigMenu("ALL_SENDER_ID")}
										/>
									)}
									{configMenuId === "UPDATE_SENDERID" && (
										<UpdateSenderId
											hubId={hubId}
											onUpdateRecord={() => setConfigMenu("ALL_SENDER_ID")}
										/>
									)}
									{configMenuId === "ALL_DLTENTITY_ID" && (
										<AllDLTEntityId hubId={hubId} />
									)}
									{configMenuId === "ALL_WHATSAPP_CONFIG" && (
										<AllWhatsAppConfig
											hubId={hubId}
											onAddWhatsAppConfig={() =>
												setConfigMenu("ADD_WHATSAPP_CONFIG")
											}
											onUpdateWhatsAppConfig={() =>
												setConfigMenu("UPDATE_WHATSAPP_CONFIG")
											}
										/>
									)}
									{configMenuId === "ADD_WHATSAPP_CONFIG" && (
										<AddWhatsAppConfig
											hubId={hubId}
											onAddWhatsAppConfig={() =>
												setConfigMenu("ALL_WHATSAPP_CONFIG")
											}
										/>
									)}
									{configMenuId === "UPDATE_WHATSAPP_CONFIG" && (
										<UpdateWhatsAppConfig
											hubId={hubId}
											onUpdateWhatsAppConfig={() =>
												setConfigMenu("ALL_WHATSAPP_CONFIG")
											}
										/>
									)}
								</div>
							</div>
						)}

						{screenId === "TEMPLATE_MANAGER" && (
							<div className="flex flex-row justify-center h-full gap-4">
								<SideMenu
									menuList={[
										{ id: "ALL_TEMPLATES", text: "SMS Templates" },
										{ id: "UPLOAD_TEMPLATES", text: "Upload Templates" },
										{
											id: "ALL_WHATSAPP_TEMPLATES",
											text: "WhatsApp Templates"
										}
									]}
									screenId={templateMenuId}
									setActiveScreenId={setTemplateMenu}
								/>
								<div className="flex flex-col flex-1 overflow-x-auto ">
									{templateMenuId === "ALL_TEMPLATES" && (
										<TemplateTable
											hubId={hubId}
											onAddTemplate={() => setTemplateMenu("ADD_TEMPLATE")}
											onUpdateTemplate={() =>
												setTemplateMenu("UPDATE_TEMPLATE")
											}
										/>
									)}
									{templateMenuId === "ADD_TEMPLATE" && (
										<AddTemplate
											hubId={hubId}
											onAddTemplate={() => setTemplateMenu("ALL_TEMPLATES")}
										/>
									)}
									{templateMenuId === "UPDATE_TEMPLATE" && (
										<UpdateTemplate
											hubId={hubId}
											onUpdateTemplate={() =>
												setTemplateMenu("ALL_TEMPLATES")
											}
										/>
									)}
									{templateMenuId === "UPLOAD_TEMPLATES" && (
										<UploadXl2Json
											hubId={hubId}
											onAddTemplate={() => setTemplateMenu("ALL_TEMPLATES")}
										/>
									)}
									{templateMenuId === "ALL_WHATSAPP_TEMPLATES" && (
										<WhatsAppTemplateTable
											hubId={hubId}
											onAddWhatsAppTemplate={() =>
												setTemplateMenu("ADD_WHATSAPP_TEMPLATE")
											}
											onUpdateWhatsAppTemplate={() =>
												setTemplateMenu("UPDATE_WHATSAPP_TEMPLATE")
											}
										/>
									)}
									{templateMenuId === "UPDATE_WHATSAPP_TEMPLATE" && (
										<WhatsAppUpdateTemplate
											hubId={hubId}
											onUpdateWhatsAppTemplate={() =>
												setTemplateMenu("ALL_WHATSAPP_TEMPLATES")
											}
										/>
									)}
								</div>
							</div>
						)}

						{screenId === "SMS_MANAGER" && (
							<div className="flex flex-row justify-center h-full gap-4">
								<SideMenu
									menuList={[
										{
											id: "SEND_SMS",
											text: (
												<>
													SMS/WhatsApp
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												</>
											)
										},
										{ id: "ALL_CAMPAIGN", text: "Campaign" }
									]}
									screenId={smsMenuId}
									setActiveScreenId={setSmsMenu}
								/>
								<div className="flex flex-col flex-1 overflow-x-auto ">
									{smsMenuId === "SEND_SMS" && <SmsHandler hubId={hubId} />}

									{smsMenuId === "ALL_CAMPAIGN" && (
										<AllCampaign
											hubId={hubId}
											onAddConfig={() => setSmsMenu("ADD_CAMPAIGN")}
											onUpdateConfig={() => setSmsMenu("UPDATE_CAMPAIGN")}
										/>
									)}
									{smsMenuId === "ADD_CAMPAIGN" && (
										<AddCampaign
											hubId={hubId}
											onAddCampaign={() => setSmsMenu("ALL_CAMPAIGN")}
										/>
									)}
									{smsMenuId === "UPDATE_CAMPAIGN" && (
										<UpdateCampaign
											hubId={hubId}
											onUpdateCampaign={() => setSmsMenu("ALL_CAMPAIGN")}
										/>
									)}
								</div>
							</div>
						)}

						{screenId === "DELIVERY_LOG" && (
							<div className="flex flex-row justify-center h-full gap-4">
								<SideMenu
									menuList={[
										{
											id: "ALL_DELIVERY_LOG",
											text: (
												<>
													Delivery Logs
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
												</>
											)
										}
										// { id: 'UPLOAD_TEMPLATES', text: 'Upload Templates', },
									]}
									screenId={smsDeliveryLogMenuId}
									setActiveScreenId={setsmsDeliveryLogMenu}
								/>
								<div className="flex flex-col flex-1 overflow-x-auto ">
									{smsDeliveryLogMenuId === "ALL_DELIVERY_LOG" && (
										<DeliveryLogHandler hubId={hubId} />
									)}
								</div>
							</div>
						)}
					</div>
				</div>
			)}
		</>
	)
}

export default Dashboard
